export enum MergeModeEnum {
  Grading,
  Merge,
  MergeResult,
  Interview,
}
